import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuService } from '../../../services/menu.service';

@Component({
  selector: 'lib-child-menu',
  templateUrl: './child-menu.component.html',
  styleUrls: ['./child-menu.component.css']
})
export class ChildMenuComponent implements OnInit {
  @Input() parentId: number;
  @Input() settings: any;

  constructor(
    public menuService: MenuService,
    private router: Router) { }

  ngOnInit() {
  }

  public navigateTo(slug, el) {
    if (!el) {
      this.router.navigate([slug]);
    }
    if (el && slug) {
      this.router.navigate([slug]);
      setTimeout(() => {
        const elmnt = document.getElementById(el);
        if (elmnt && elmnt != null) {
          elmnt.scrollIntoView();
        }
      }, 200);
    }

  }

}
